import React, { useCallback, useMemo, useRef } from 'react';
import { createCreateNewMenu } from 'reactApp/ui/ContextMenu/createContextMenuList';
import { renderContextMenu } from 'reactApp/ui/ContextMenu/createContextMenuToolkit';
import { DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { AddIcon } from 'reactApp/ui/VKUIIcons';
import { sendGa } from 'reactApp/utils/ga';

import styles from '../EmptyFolder.css';
import { getPopupPosition } from '../EmptyFolder.helpers';
import { gaSuffix } from '../EmptyFolder.types';

export const useCreate = () => {
    const createRef = useRef<HTMLInputElement>(null);

    const Create = useMemo(
        () => (
            <div className={styles.icon} ref={createRef}>
                <AddIcon />
            </div>
        ),
        [createRef]
    );

    const handleClickCreateNew = useCallback(() => {
        if (!createRef.current) {
            return;
        }

        sendGa(gaSuffix, 'create');

        renderContextMenu({
            theme: DropdownTheme.medium,
            menuItems: createCreateNewMenu({ createFrom: 'empty-folder' }),
            ...getPopupPosition(createRef.current),
        });
    }, []);

    return useCallback(() => {
        return {
            title: 'Создать документ или папку',
            annotation: 'Вы можете создать пустую папку, шаблон таблицы, документа или презентации',
            onClick: handleClickCreateNew,
            Icon: Create,
        };
    }, [Create, handleClickCreateNew]);
};
